import React, { useContext, useEffect } from 'react';
import Layout from './components/Layout';
import LayoutContent from './components/LayoutContent';
import { RoutePaths } from './Constants/Common';
import { SiteContext } from './context/SiteContext';
import './App.scss';
import VehicleProvider from './context/VehicleProvider';
import CustomerProvider from './context/CustomerProvider';
import Auth0ProviderWithHistory from './components/common/auth0ProviderWithHistory/Auth0ProviderWithHistory';
import LoadingContainer from './components/common/loadingContainer/LoadingContainer';
import { useNavigate } from 'react-router-dom';
import i18n, { t } from 'i18next';

const App = (): JSX.Element => {
    const {
        brandId,
        brandStyles,
        brandSearchComplete,
        clientId,
        domain,
        audience
    } = useContext(SiteContext);

    const navigate = useNavigate();

    useEffect(() => {
        if (window.location.pathname.split('/').length > 0) {
            i18n.languages.includes(window.location.pathname.split('/')[1]) &&
                i18n.changeLanguage(window.location.pathname.split('/')[1]);
        }
    });

    useEffect(() => {
        if (brandSearchComplete && brandId <= 0) {
            navigate(RoutePaths.GeneralError);
        }
    }, [brandSearchComplete]);

    return (
        <LoadingContainer loading={!brandSearchComplete} message={t('loading')}>
            <Auth0ProviderWithHistory
                clientId={clientId}
                domain={domain}
                audience={audience}>
                <VehicleProvider>
                    <CustomerProvider>
                        <Layout brandStyles={brandStyles}>
                            <LayoutContent></LayoutContent>
                        </Layout>
                    </CustomerProvider>
                </VehicleProvider>
            </Auth0ProviderWithHistory>
        </LoadingContainer>
    );
};

export default App;
